<template>
  <div class="preview-input">
    <input
    class="classic-input input-customize big col-small-vspace col-big-hspace"
    ref="test"
    :value="name === 'Widddi' ? 'Tapez le prénom ici...' : name"
    @input="modifyName"
    @focus="resetName"
    @blur="backName"
    autocomplete="off"
    spellcheck="false"
    autocorrect="off">
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: 'Widddi',
    },
    typo: {
      type: String,
    },
    stand: {
      type: Boolean,
      default: false,
    },
    acceptSpace: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      maxLength: 10,
      downLetterByFont: {
        typo6: [],
      },
      acceptedLetters: 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZéèêëïîà^ç¨0123456789,+=&@#!()-./? `',
    };
  },

  methods: {
    resetName() {
      if (this.name === 'Widddi') {
        this.$emit('change-name', '');
      }
    },
    backName() {
      if (this.name === '') {
        this.$emit('change-name', 'Widddi');
      }
    },
    modifyName(ev) {
      this.emitKeydown(ev.target.value, this.name)
        .then(response => this.isDownLetter(this.typo, response))
        .then((response) => {
          this.$emit('change-name', response.data);
          if (response.message === 'downletter' && !this.stand) this.$emit('handle-error', response.message);
        })
        .catch((error) => {
          ev.target.value = error.data;
          this.$emit('handle-error', error.message);
        });
    },
    emitKeydown(newVal, oldVal) {
      return new Promise((resolve, reject) => {
        if (newVal === null) reject({ message: 'empty', data: '' });
        newVal.split('').forEach((char) => {
          if (this.acceptedLetters.indexOf(char) === -1) {
            reject({ message: 'wrongchar', data: oldVal });
          } else if (newVal.length > this.maxLength) {
            reject({ message: 'toolong', data: oldVal });
          }
        });

        if (!this.acceptSpace) {
          newVal = newVal.replace(/\s/g, '');
        }

        resolve(newVal);
      });
    },
    isDownLetter(font, value) {
      return new Promise((resolve) => {
        value.split('').forEach((char) => {
          if (this.downLetterByFont[font].indexOf(char) > -1) {
            resolve({ message: 'downletter', data: value });
          }
        });
        resolve({ message: 'no downletter', data: value });
      });
    },
  },
};
</script>
